import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOpenCalls, fetchOpenCallsWithFilters } from '../services/api';

// Old endpoint - kept for backward compatibility
export const getOpenCalls = createAsyncThunk('opencalls/getOpenCalls', async (openCallId = null) => {
    const response = await fetchOpenCalls(openCallId);
    return response.data;
});

// New endpoint with filters and pagination
export const getOpenCallsWithFilters = createAsyncThunk(
    'opencalls/getOpenCallsWithFilters',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await fetchOpenCallsWithFilters(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch open calls');
        }
    }
);

const openCallSlice = createSlice({
    name: 'opencalls',
    initialState: {
        openCalls: [],
        status: 'idle',
        error: null,
        pagination: {
            page: 1,
            page_size: 20,
            count: 0,
            total_count: 0,
            total_pages: 0,
        },
        filters: {},
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        resetFilters: (state) => {
            state.filters = {};
        },

        updatePinnedStatus: (state, action) => {

            const { id, pinned } = action.payload;

            const openCall = state.openCalls.find(
                (item) =>
                    item.open_call_id === id ||
                    item.id === id
            );

            if (openCall) {

                openCall.pinned = pinned;

            }

        },

    },
    extraReducers: (builder) => {
        builder
            // Old endpoint handlers
            .addCase(getOpenCalls.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getOpenCalls.fulfilled, (state, action) => {
                state.openCalls = action.payload.data || action.payload;
                state.status = 'succeeded';
            })
            .addCase(getOpenCalls.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // New endpoint handlers
            .addCase(getOpenCallsWithFilters.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getOpenCallsWithFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === 1 || action.payload.data) {
                    state.openCalls = action.payload.data || [];
                    if (action.payload.pagination) {
                        state.pagination = {
                            page: action.payload.pagination.page || 1,
                            page_size: action.payload.pagination.page_size || 20,
                            count: action.payload.pagination.count || 0,
                            total_count: action.payload.pagination.total_count || 0,
                            total_pages: action.payload.pagination.total_pages || 0,
                        };
                    }
                } else {
                    state.openCalls = [];
                    state.error = 'Failed to fetch open calls';
                }
            })
            .addCase(getOpenCallsWithFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const { setFilters, resetFilters, updatePinnedStatus } = openCallSlice.actions;
export default openCallSlice.reducer;